<script>
	import Pane from './Pane'
	import Header from './Header'
	import {range} from '@lib'

	let panes = 4
	let cols = 2

	const defaults = [
		'Connector',
		'State',
		'Controls',
		'Stream',
		'Console',
		'JsState',
		'XmlState',
	]
</script>

<Header  bind:panes bind:cols />

<main class="cols-{cols} rows-{Math.ceil(panes/cols)}">
{#each range(0, panes-1) as i}
	<Pane component={defaults[i]} />
{/each}
</main>

<style>
	.cols-1 {
		grid-template-columns: 1fr;
	}
	.cols-2 {
		grid-template-columns: 1fr 1fr;
	}
	.cols-3 {
		grid-template-columns: 1fr 1fr 1fr;
	}

	.rows-2 {
		grid-template-rows: 1fr 1fr;
	}

	.rows-3 {
		grid-template-rows: 1fr 1fr 1fr;
	}

	/* The rest of the rows-N cases should use normal flow */
</style>
